import { compose } from 'recompose';
import { connect } from 'react-redux';

import BarberPicker from '../components/BarberPicker';
import { getAll as getAllBarbers } from '../../../main/barbers/selector';

export default compose(
  connect(
    state => ({
      barbers: getAllBarbers(state),
    }),
  ),
)(BarberPicker);
